import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import shortid from "shortid";
import getAllOrderReviews from "../store/orderReviews/getAll/actions";

const useAllOrderReviews = () => {
    const [formatedData, setFormatedData] = useState([]);

    const dispatch = useDispatch();
    const { loading, data, error } = useSelector(
        (store) => store.getAllOrderReviews
    );

    useEffect(() => {
        if (!data[0]) {
            dispatch(getAllOrderReviews());
        }
    }, [dispatch]);

    useEffect(() => {
        setFormatedData(
            data.reduce((acc, ele) => {
                acc.push({
                    key: shortid.generate(),
                    ...ele,
                });
                return acc;
            }, [])
        );
    }, [data]);

    return [loading, formatedData, error];
};
export default useAllOrderReviews;
